const faq = document.querySelectorAll(".faq__list--qn");

export function plsClickMe(event){
    event.classList.toggle("clicked");
}